import styled from 'styled-components';

import { colorAppIcon, colorAppBackground, colorAppFieldBorder } from 'common/styles/colors';
import { baseFontSize, latoLineHeight } from 'common/styles/typography';
import {
    containerPaddingXs,
    containerPaddingS,
    containerPaddingSm,
    containerPaddingM,
    baseBorderRadius,
    baseBorderWidth,
} from 'common/styles/variables';
import { TRANSITION_TIMEOUT, TRANSITION_TIMEOUT_SHORT } from 'common/constants';

const ITEM_REM_HEIGHT = 1.75;
const getIconTransition = (timeout) => `
    opacity ${timeout}ms ease-in-out,
    right ${timeout}ms ease-in-out
`;

const getHoverColor = ({ isDisabled, theme }) => (isDisabled ? '' : theme.palette.grayscale.gray50);

export const IconContainer = styled.div`
    position: absolute;
    opacity: 0;
    right: 0;
    top: ${ITEM_REM_HEIGHT / 2}rem;
    color: ${colorAppIcon};
    padding-left: ${containerPaddingS};
    background: ${colorAppBackground};
    transition: ${getIconTransition(TRANSITION_TIMEOUT_SHORT)};

    :hover {
        color: ${({ theme }) => theme.palette.primary.main};
    }
`;

export const LabelContainer = styled.div`
    text-align: left;
    word-break: break-all;
    height: ${ITEM_REM_HEIGHT}rem;

    p {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: pre;

        &:first-child {
            font-size: ${baseFontSize};
        }

        &:last-child {
            opacity: 0.5;
        }
    }
`;

export const TemplateLibraryWrapper = styled.div`
    margin: ${containerPaddingXs} 0;
    min-width: 10rem;
    flex-basis: 30%;
    position: relative;
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
    outline: none;
    background-color: ${({ theme }) => theme.palette.grayscale.white};
    border: ${baseBorderWidth} solid ${colorAppFieldBorder};
    border-radius: ${baseBorderRadius};
    padding: ${containerPaddingSm} ${containerPaddingS};
    line-height: ${latoLineHeight};
    /* This !important is due to the transition HOC wrapping the TemplateLibraryWrapper
    adding always an opacity of 1. So we need to override it in case a question is disabled. */
    opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)} !important;

    ${(props) =>
        props.isSelected &&
        `
        border-color: ${({ theme }) => theme.palette.primary.main};
        color: ${({ theme }) => theme.palette.primary.main};
    `};

    &:hover,
    &:focus {
        div {
            opacity: 1;
            transition: ${getIconTransition(TRANSITION_TIMEOUT)};
            right: ${containerPaddingM};
        }

        border-color: ${(props) => getHoverColor(props)};
    }
`;
